import React from 'react'
import './FooterLinking.css'
import FooterLeftAreaCard from './FooterLeftAreaCard'
import FooterRightAreaCard from './FooterRightAreaCard'

function FooterLinking() {
    return (
        <div className="FooterLinking">
            <FooterLeftAreaCard />
            <FooterRightAreaCard />
        </div>
    )
}

export default FooterLinking
